// extracted by mini-css-extract-plugin
export default {"page":"Loader_page__VBZvm","loader":"Loader_loader__hj1i8","load8":"Loader_load8__6uu9G"};